import React from 'react'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import CircularProgressAtom from '../../@atoms/to_forms/circular_progress/circular_progress.atom'
import SkeletonAtom from '../../@atoms/to_layout/skeleton/skeleton.atom'
import TextfieldAtom from '../../@atoms/to_forms/textfield/textfield.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import useLoginForm from '../../@hooks/use_login_form'
import {AuthenticationTypeProps} from '../../props_reusable/authentication'
import utils from '../../utils'

interface LoginFormComponentProps {
  authenticateType: AuthenticationTypeProps
}

const LoginFormComponent: React.FC<LoginFormComponentProps> = function ({
  authenticateType,
}) {
  const {inputs, formik, loader, labels, setLoader} =
    useLoginForm(authenticateType)

  if (utils.isObjectEmpty(labels))
    return <SkeletonAtom ap_type="login_form_skeleton" />

  const {login} = labels
  const {handleSubmit, values, handleChange, touched, errors} = formik
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange(event)
    if (loader.message) setLoader(prevState => ({...prevState, message: ''}))
  }
  return (
    <form onSubmit={handleSubmit}>
      {inputs.orderCode && (
        <BoxAtom className="input-wrapper-box">
          <TextfieldAtom
            fullWidth
            id="order-code-input"
            label={login.orderCodeInputName}
            name="orderCode"
            value={values.orderCode}
            onChange={onChange}
            error={touched.orderCode && !!errors.orderCode}
            helperText={login.orderCodeHelperText}
          />
        </BoxAtom>
      )}
      {inputs.postalCode && (
        <BoxAtom className="input-wrapper-box">
          <TextfieldAtom
            fullWidth
            id="postal-code-input"
            label={login.postalCodeInputName}
            name="postalCode"
            value={values.postalCode}
            onChange={onChange}
            error={touched.postalCode && !!errors.postalCode}
            helperText={login.postalCodeHelperText}
          />
        </BoxAtom>
      )}
      <BoxAtom className="error-wrapper-box">
        <TypographyAtom ahd_type="step" ap_color="error">
          {loader.message}
        </TypographyAtom>
      </BoxAtom>
      <BoxAtom
        className={utils.classnames({
          'login-submit-btn-wrapper-box': true,
          'cursor-not-allowed': loader.loading,
        })}
      >
        <ButtonAtom
          className={loader.loading ? 'btn-disabled' : ''}
          ap_type="primary"
          fullWidth
          type="submit"
        >
          {loader.loading ? (
            <CircularProgressAtom size="1.5rem" ap_type="btn_spinner" />
          ) : (
            `${login.buttonFormSubmit}`
          )}
        </ButtonAtom>
      </BoxAtom>
    </form>
  )
}

export default LoginFormComponent
